import React from 'react';
import { Hydrate } from 'react-query/hydration';
import { QueryClient, QueryClientProvider } from 'react-query';
import deepmergeWithArrays from '@sls-react/utils/deepmergeWithArrays';

interface Props {
  pageProps: any;
  dehydratedState: any;
}

const ReactQueryApp: React.FC<Props> = ({
  children,
  dehydratedState,
  pageProps,
}) => {
  const queryClientRef = React.useRef<QueryClient>();
  if (!queryClientRef.current) {
    queryClientRef.current = new QueryClient();

    if (typeof window !== 'undefined') {
      window['__sls_reactQueryClient'] = queryClientRef.current;
    }
  }

  return (
    <QueryClientProvider client={queryClientRef.current}>
      <Hydrate
        state={{
          queries: [
            ...(dehydratedState?.queries || []),
            ...(pageProps.dehydratedState?.queries || []),
          ],
          mutations: [
            ...(dehydratedState?.mutations || []),
            ...(pageProps.dehydratedState?.mutations || []),
          ],
        }}
      >
        {children}
      </Hydrate>
    </QueryClientProvider>
  );
};

export default ReactQueryApp;
